<template>
<div class="header-search-wrapper">
  <div class="search-tab">
    <span :class="{ selected: selectedTab===0 }" v-on:click="handleTabClick(0)">应用</span>
    <span :class="{ selected: selectedTab===1 }" v-on:click="handleTabClick(1)">供应商</span>
  </div>
  <div class="search-input-wrapper">
    <i :class="['iconfont','icon-search']"></i>
    <input :placeholder="palceholder[selectedTab]" v-model="searchKeywords" v-on:keyup.enter="handleSearch" />
    <button @click="handleSearch">搜索</button>
  </div>
</div>
</template>

<script>
import qs from 'querystringify';
export default {
  data () {
    return {
      selectedTab: 0,
      searchKeywords: qs.parse(window.location.search).q || '',
      palceholder: ['输入要搜索的应用', '输入要搜索的供应商']
    };
  },
  methods: {
    handleTabClick (index) {
      this.selectedTab = index;
    },
    handleSearch () {
      // console.log(`/search?type=${this.selectedTab}&q=${this.searchKeywords}`);
      this.selectedTab === 0 ? location.href = `/search.html?q=${this.searchKeywords}` : location.href = `/search-shop.html?shopName=${this.searchKeywords}`;
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
@search-border: #4779e3;
@search-input-width: 520px;
@search-input-height: 40px;
@search-button-height: 36px;
.header-search-wrapper {
  font-family: @family-nomal;
  .search-tab {
    padding-left: 5px;
    span {
      display: inline-block;
      border-radius: @border-radius-normal @border-radius-normal 0 0;
      height: 22px;
      line-height: 22px;
      padding: 0 0.8em;
      text-align: center;
      font-size: @font-size-s;
      color: @tab-unselected-color;
      background: @tab-unselected-bg;
      cursor: pointer;
    }
    span.selected {
      color: @tab-selected-color;
      background: @tab-selected-bg;
    }
  }
  .search-input-wrapper {
    display: flex;
    justify-content: space-between;
    border: 2px solid @search-border;
    border-radius: @border-radius-normal;
    width: @search-input-width;
    line-height: @search-input-height;
    height: @search-input-height;
    box-sizing: border-box;
    padding: 0;
    i {
      color:#9b9b9b;
      font-size:@font-size-m;
      margin: 0 1em;
    }
    input {
      flex: 1;
      border: 0;
    }
    input:focus {
      outline: none;
    }
    button {
      height: @search-button-height;
      line-height: @search-button-height;
      border-radius: 0 @border-radius-normal @border-radius-normal 0;
      background: @color-blue;
      color: #fff;
      border: 0;
      width: 72px;
      margin: 0 -2px 0 0;
      padding: 0;
      cursor: pointer;
      font-size: @font-size-l;
    }
    button:focus {
      outline: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/header/search.vue